import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [state, setState] = useState({ loading: false, ok: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();

    if (!token) {
      setState({ loading: false, ok: false, error: "Token manquant." });
      return;
    }
    if (!pwd || pwd.length < 6) {
      setState({ loading: false, ok: false, error: "Mot de passe trop court (6 caractères minimum)." });
      return;
    }
    if (pwd !== pwd2) {
      setState({ loading: false, ok: false, error: "Les mots de passe ne correspondent pas." });
      return;
    }

    setState({ loading: true, ok: false, error: "" });
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setState({ loading: false, ok: true, error: "" });
    } catch (e2) {
      const msg = e2?.response?.data?.detail || "Réinitialisation impossible (token invalide ou expiré).";
      setState({ loading: false, ok: false, error: msg });
    }
  };

  return (
    <div className="min-h-screen bg-[#1d191a] text-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white/5 border border-white/10 rounded-2xl p-6">
        <h1 className="text-xl font-semibold">Nouveau mot de passe</h1>

        {state.ok ? (
          <div className="mt-3 text-sm text-white/80">
            <p>✅ Mot de passe mis à jour.</p>
            <div className="mt-6">
              <Link
                to="/"
                className="inline-block bg-amber-500 hover:bg-amber-600 text-black px-4 py-2 rounded-xl"
              >
                Revenir à UrbSex
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-3">
            <div>
              <label className="text-sm text-white/70">Nouveau mot de passe</label>
              <input
                className="mt-1 w-full rounded-xl bg-black/30 border border-white/10 px-3 py-2"
                type="password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
              />
            </div>

            <div>
              <label className="text-sm text-white/70">Confirmer</label>
              <input
                className="mt-1 w-full rounded-xl bg-black/30 border border-white/10 px-3 py-2"
                type="password"
                value={pwd2}
                onChange={(e) => setPwd2(e.target.value)}
              />
            </div>

            {state.error && <p className="text-sm text-red-300">{state.error}</p>}

            <button
              type="submit"
              disabled={state.loading}
              className="w-full rounded-xl bg-emerald-500 hover:bg-emerald-600 text-black px-4 py-2"
            >
              {state.loading ? "En cours…" : "Valider"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}